import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { ShareAssetFieldInfo } from '../../fragments/generated/ShareAssetFieldInfo';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateShareFieldsCardMutationVariables = Types.Exact<{
  shareId: Types.Scalars['ID']['input'];
  fieldsCard?: Types.InputMaybe<Array<Types.CollectionFieldInput>>;
}>;


export type UpdateShareFieldsCardMutation = { __typename?: 'Mutation', updateShare?: { __typename?: 'UpdateSharePayload', share?: { __typename?: 'AdHocAssetsShare', id: string, fieldsCard?: { __typename?: 'ShareFieldConnection', totalCount: number, nodes: Array<{ __typename?: 'ShareField', isFrozen?: boolean | null, isVisible?: boolean | null, width?: number | null, fieldDefinition?: { __typename?: 'ProjectFieldDefinition', id: string, name: string } | null } | null> } | null } | { __typename?: 'CollectionShare', id: string, fieldsCard?: { __typename?: 'ShareFieldConnection', totalCount: number, nodes: Array<{ __typename?: 'ShareField', isFrozen?: boolean | null, isVisible?: boolean | null, width?: number | null, fieldDefinition?: { __typename?: 'ProjectFieldDefinition', id: string, name: string } | null } | null> } | null } | null } | null };


export const UpdateShareFieldsCard = /*#__PURE__*/ gql`
    mutation UpdateShareFieldsCard($shareId: ID!, $fieldsCard: [CollectionFieldInput!]) {
  updateShare(input: {shareId: $shareId, fieldsCard: $fieldsCard}) {
    share {
      id
      ... on AssetAggregate {
        fieldsCard(page: {first: 100}) {
          nodes {
            ...ShareAssetFieldInfo
          }
          totalCount
        }
      }
    }
  }
}
    ${ShareAssetFieldInfo}` as unknown as DocumentNode<UpdateShareFieldsCardMutation, UpdateShareFieldsCardMutationVariables>;

          

          export const useUpdateShareFieldsCardMutation = (options?:MutationHookOptions<UpdateShareFieldsCardMutation, UpdateShareFieldsCardMutationVariables>) => useMutation(UpdateShareFieldsCard, options);
          

          export type UpdateShareFieldsCardMutationOptions = MutationHookOptions<UpdateShareFieldsCardMutation, UpdateShareFieldsCardMutationVariables>;

          

          export type UpdateShareFieldsCardMutationResult = ReturnType<typeof useUpdateShareFieldsCardMutation>[1];

          
